const GRIDABLE_MEDIA_TYPES = new Set(["image", "sticker", "video"]);

const MEDIA_GROUP_GAP_MS = 10_000;

const getMessageTime = (message) =>
  new Date(message?.time || message?.created_at || 0).getTime();

export const isGridableMediaMessage = (message) => {
  if (!message || message.msgType === "date") {
    return false;
  }

  const type = String(message.msgType || message.type || "").toLowerCase();
  return GRIDABLE_MEDIA_TYPES.has(type);
};

/**
 * Groups consecutive image/video messages from the same sender
 * sent within a short window (same album-style batch).
 */
export const groupMessagesForDisplay = (messages = []) => {
  const items = [];
  let index = 0;

  while (index < messages.length) {
    const message = messages[index];

    if (message.msgType === "date") {
      items.push({ kind: "date", message });
      index += 1;
      continue;
    }

    if (!isGridableMediaMessage(message)) {
      items.push({ kind: "single", message });
      index += 1;
      continue;
    }

    const batch = [message];
    let nextIndex = index + 1;

    while (nextIndex < messages.length) {
      const nextMessage = messages[nextIndex];
      if (
        nextMessage.msgType === "date" ||
        !isGridableMediaMessage(nextMessage) ||
        nextMessage.from !== message.from
      ) {
        break;
      }

      const gap =
        getMessageTime(nextMessage) - getMessageTime(batch[batch.length - 1]);
      if (gap > MEDIA_GROUP_GAP_MS) {
        break;
      }

      batch.push(nextMessage);
      nextIndex += 1;
    }

    if (batch.length > 1) {
      items.push({ kind: "media_group", messages: batch });
    } else {
      items.push({ kind: "single", message });
    }

    index = nextIndex;
  }

  return items;
};

export const groupContainsImage = (messages = []) =>
  messages.some((message) => {
    const type = String(message.msgType || message.type || "").toLowerCase();
    return type === "image" || type === "sticker";
  });
